/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationInfo
 */
export interface PaginationInfo {
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the PaginationInfo interface.
 */
export function instanceOfPaginationInfo(value: object): value is PaginationInfo {
    return true;
}

export function PaginationInfoFromJSON(json: any): PaginationInfo {
    return PaginationInfoFromJSONTyped(json, false);
}

export function PaginationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function PaginationInfoToJSON(json: any): PaginationInfo {
    return PaginationInfoToJSONTyped(json, false);
}

export function PaginationInfoToJSONTyped(value?: PaginationInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'totalItems': value['totalItems'],
        'totalPages': value['totalPages'],
    };
}

